import React from 'react'
import "./Announcement_card.css"

function Announcement_card({ name, description, date }) {
  return (
    <>
      <section className='Announcement_card'>
        <div className='heading_hodler'>
          <h6><div className='icon_img_holder'><img src='/assets/images/icons/announcement.png' className='icon_img' alt='img icon' /></div>{name}</h6>
          <p>{description}</p>
          <span>{date}</span>
        </div>
      </section>
    </>
  )
}

export default Announcement_card